"use client"
import cn from "clsx";
import styles from "../reviews.module.scss";

import { useState, useEffect } from "react";
import UKToast from "@/common-components-src/components/UKToast/index";;
import { HelpfulProps } from "@/app/csr-src/apis/profile/review.interface";
import { customElement, CUSTOM_DETAITL_OPTS_EVENT_HELPFUL } from "../const";
import { handleHelpfulOperation } from "@/app/csr-src/apis/profile/review.api";
import { sendClickTrack as myReviewSendClickTrack } from "@/tracks/25155";

interface HelpProps {
  data: HelpfulProps;
  pageType?: string;
  expConfig?: any;
}
export default function HelpfulButton({ data, pageType, expConfig }: HelpProps) {
  const { helpfulNum, commentId, currentIsHelp } = data || {};
  const [helpNum, setHelpNum] = useState<string>(helpfulNum || "0");
  const [helpfulState, setHelpfulState] = useState<boolean>(currentIsHelp);

  const onHandle = async (event: React.MouseEvent) => {
    const res = await handleHelpfulOperation({
      commentId: commentId,
      operation: helpfulState ? 2 : 1,
    });
    if (res?.data?.result) {
      setHelpfulState(!helpfulState);
      const { likeCount } = res?.data || {};
      setHelpNum(likeCount !== "0" ? likeCount || "0" : "0");
      customElement.dispatchEvent(
        new CustomEvent(CUSTOM_DETAITL_OPTS_EVENT_HELPFUL, {
          detail: {
            data: {
              [commentId]: {
                helpfulState: !helpfulState,
                helpfulNum: likeCount,
              },
            },
          },
        }),
      );
    } else {
      UKToast.show({
        icon: "error",
        content: res?.msg || "Oops! Something went wrong. Please try again.",
      });
    }
    event.preventDefault();
  };

  const handleEvent = (e: Event) => {
    const { detail } = e as CustomEvent;
    if (detail?.data?.[commentId]) {
      const { helpfulNum, helpfulState } = detail?.data?.[commentId] || {};
      setHelpNum(helpfulNum || "0");
      setHelpfulState(helpfulState);
    }
  };

  useEffect(() => {
    customElement.addEventListener(CUSTOM_DETAITL_OPTS_EVENT_HELPFUL, handleEvent);
    return () => {
      customElement.removeEventListener(CUSTOM_DETAITL_OPTS_EVENT_HELPFUL, handleEvent);
    };
  }, []);

  return (
    <div className={cn(styles.helpfulBtn, helpfulState ? styles.active : "")} 
      exptag={expConfig?.help?.expTag}
      data-exptag-json-param={JSON.stringify(expConfig?.help?.data)}
      data-exptag-config={expConfig?.help?.config}
      onClick={(e: any)=>{
        /** 点击事件上报-已完成评价tab下按钮点击 */
        switch (pageType) {
          case "reviewComment":
            // {"button_name":"1-helpful，2-comment，3-more","commentId":""}
            myReviewSendClickTrack.My_Reviews_Completed_Btn({button_name: "1", commentId: `${commentId}`})
            break;
        
          default:
            break;
        }
        onHandle?.(e);
      }}>
      <i className={cn(styles.zanIcon, styles.mar)}></i>
      {`Helpful${helpNum !== "0" ? "(" + helpNum + ")" : ""}`}
    </div>
  );
}
